export default {
  props: {
    document: {
      type: Array[Object],
      required: true,
    },
  },
}
